import PlayerTimelineButton from './PlayerTimelineButton';
import { useAddScene } from '../TimelineSegments/TimelineScenes/useAddScene';

const AddScene = () => {
  const { addSceneMenuItem } = useAddScene();
  if (!addSceneMenuItem) {
    return null;
  }

  return (
    <PlayerTimelineButton
      tooltipTitle={addSceneMenuItem.label}
      buttonId="timeline-add-scene-button"
      iconName={addSceneMenuItem.iconName}
      isDisabled={addSceneMenuItem.isDisabled}
      onClick={addSceneMenuItem.onClick}
    />
  );
};

export default AddScene;
